import isAvailable from './is-available';
import isHeaderBlock from './is-header-block';
import isNavigationGlobalElement from './is-navigation-global-element';

export default {
  isAvailable,
  isHeaderBlock,
  isNavigationGlobalElement,
};
